import React from "react";

export default function About() {
  return (
    <main className="w-full bg-white">
      {/* ================================================= */}
      {/*                 MAIN ABOUT SECTION                */}
      {/* ================================================= */}

      <section className="w-full bg-white">
        <div className="grid grid-cols-1 lg:grid-cols-2">
          {/* ================================================= */}
          {/*                    LEFT IMAGE                     */}
          {/* ================================================= */}

          <div className="relative h-[450px] w-full overflow-hidden sm:h-[550px] lg:h-[750px]">
            <img
              src="/gallery1.jpg"
              alt="Capeesh restaurant food"
              className="h-full w-full object-cover transition-transform duration-700 hover:scale-105"
            />

            <div className="absolute inset-0 bg-black/5" />
          </div>

          {/* ================================================= */}
          {/*                  RIGHT CONTENT                    */}
          {/* ================================================= */}

          <div className="flex items-center bg-white px-8 py-20 text-black sm:px-12 md:px-16 lg:px-20 xl:px-28">
            <div className="w-full max-w-xl">
              {/* Small Heading */}

              <p className="mb-5 text-xs font-bold uppercase tracking-[0.35em] text-[#b08d27]">
                Welcome to Capeesh
              </p>

              {/* Main Heading */}

              <h2 className="font-sans text-5xl font-bold uppercase leading-[0.9] tracking-[-0.04em] sm:text-6xl md:text-7xl">
                About Us:
              </h2>

              {/* Gold Line */}

              <div className="mt-8 h-[2px] w-16 bg-[#d4af37]" />

              {/* Description */}

              <div className="mt-10 space-y-6 font-serif text-lg leading-8 text-black/80 sm:text-xl">
                <p>
                Paris, Ontario, founded by Hiram Capron on May 7, 1829, earned its name from nearby gypsum deposits used in plaster of Paris. Officially established in 1856, it's known as the "Cobblestone Capital of Canada" due to its unique architecture. The town etched its place in history as the recipient of the first-ever telephone call, made by Alexander Graham Bell from Brantford in 1876 to Robert White's Shoe Store.</p>
               <p> Visitors to Paris can immerse themselves in its rich heritage and natural beauty. After savoring local cuisine at restaurants like Capeesh, they can explore attractions such as Penman's Dam and the scenic Paris Trails. The town's charming downtown area offers local shops and historic sights, while nearby locations like Lions Park and Pinehurst Conservation Area provide opportunities for outdoor enthusiasts. For those interested in delving deeper into communication history, the Bell Homestead National Historic Site in neighboring Brantford offers fascinating insights into the telephone's origins
                </p>
              </div>

              {/* Brand Text */}

              <div className="mt-12 border-t border-black/10 pt-8"></div>
            </div>
          </div>
        </div>
      </section>

      {/* ================================================= */}
      {/*                 OUR EXPERIENCE                    */}
      {/* ================================================= */}

      <section className="w-full bg-[#f7f5ef] px-6 py-20 sm:px-10 sm:py-24 lg:px-12 lg:py-32">
        <div className="mx-auto max-w-7xl">
          {/* Section Header */}

          <div className="mx-auto max-w-3xl text-center">
            <h2 className="mt-5 font-serif text-4xl text-black sm:text-5xl lg:text-6xl">
              Something for everyone
            </h2>

            <div className="mx-auto mt-7 h-[2px] w-16 bg-[#d4af37]" />

            <p className="mt-7 font-serif text-lg leading-8 text-black/70 sm:text-xl">
              From relaxed lunches to memorable evenings, Capeesh is designed to
              bring people together through food, drinks, and good times.
            </p>
          </div>

          {/* Experience Cards */}

          <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-3">
            {/* Card 1 */}

            <div className="group bg-white p-8 sm:p-10">
              <div className="mb-8 aspect-[4/3] overflow-hidden">
                <img
                  src="/food1.jpg"
                  alt="Indoor Dining at Capeesh"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>

              <h3 className="font-sans text-2xl font-bold uppercase tracking-tight">
                Indoor Dining
              </h3>

              <p className="mt-4 font-serif leading-7 text-black/70">
                Enjoy our relaxed indoor spaces, from the bar and lounge to our
                dining room and fully open concept kitchen.
              </p>
            </div>

            {/* Card 2 */}

            <div className="group bg-white p-8 sm:p-10">
              <div className="mb-8 aspect-[4/3] overflow-hidden">
                <img
                  src="/food2.jpg"
                  alt="Riverside Patios at Capeesh"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>

              <h3 className="font-sans text-2xl font-bold uppercase tracking-tight">
                Riverside Patios
              </h3>

              <p className="mt-4 font-serif leading-7 text-black/70">
                Soak in the riverside atmosphere on one of our two beautiful
                patios while enjoying great food and refreshing drinks.
              </p>
            </div>

            {/* Card 3 */}

            <div className="group bg-white p-8 sm:p-10">
              <div className="mb-8 aspect-[4/3] overflow-hidden">
                <img
                  src="/food3.jpg"
                  alt="Capeesh Food and Drinks"
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                />
              </div>

              <h3 className="font-sans text-2xl font-bold uppercase tracking-tight">
                Great Food
              </h3>

              <p className="mt-4 font-serif leading-7 text-black/70">
                Handmade pizza, gourmet pasta, sandwiches, salads and flavours
                inspired by cuisines from around the world.
              </p>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}
